(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DataFormatter_ru", [], factory);
	else if(typeof exports === 'object')
		exports["DataFormatter_ru"] = factory();
	else
		root["DataFormatter_ru"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition